<template>
  <div class="manage-sidebar" :class="{ 'collapsed': isCollapsed }">
    <div class="sidebar-header">
      <transition name="fade" mode="out-in">
        <h3 v-if="!isCollapsed" key="visible" class="header-title">管理后台</h3>
        <div v-else key="hidden" class="header-placeholder"></div>
      </transition>
      <button class="collapse-btn" @click="toggleCollapse">
        <span class="iconify" :data-icon="isCollapsed ? 'hugeicons:arrow-right-01' : 'hugeicons:arrow-left-01'"></span>
      </button>
    </div>
    
    <div class="sidebar-menu">
      <router-link
        to="/manage/order/list"
        class="menu-item"
        :class="{ active: $route.path.startsWith('/manage/order') }"
      >
        <span class="menu-icon">
          <span class="iconify" data-icon="hugeicons:clipboard"></span>
        </span>
        <transition name="fade" mode="out-in">
          <span v-if="!isCollapsed" key="visible" class="menu-text">订单管理</span>
          <span v-else key="hidden" class="menu-text-placeholder"></span>
        </transition>
      </router-link>

      <router-link
        v-if="userRoleCode >= 2"
        to="/manage/user/list"
        class="menu-item"
        :class="{ active: $route.path.startsWith('/manage/user') }"
      >
        <span class="menu-icon">
          <span class="iconify" data-icon="hugeicons:user-group"></span>
        </span>
        <transition name="fade" mode="out-in">
          <span v-if="!isCollapsed" key="visible" class="menu-text">用户管理</span>
          <span v-else key="hidden" class="menu-text-placeholder"></span>
        </transition>
      </router-link>

      <router-link
        to="/manage/profile"
        class="menu-item"
        :class="{ active: $route.path === '/manage/profile' }"
      >
        <span class="menu-icon">
          <span class="iconify" data-icon="hugeicons:user"></span>
        </span>
        <transition name="fade" mode="out-in">
          <span v-if="!isCollapsed" key="visible" class="menu-text">个人中心</span>
          <span v-else key="hidden" class="menu-text-placeholder"></span>
        </transition>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ManageSidebar',
  data() {
    return {
      isCollapsed: false,
      userRoleCode: 0
    };
  },
  mounted() {
    // 从 localStorage 获取用户角色（登录时存储）
    this.getUserRole();
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.$emit('collapse-change', this.isCollapsed);
    },
    getUserRole() {
      // 从 localStorage 获取 token 解析角色
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const payload = JSON.parse(atob(token.split('.')[1]));
          this.userRoleCode = payload.roleCode || 0;
        } catch (e) {
          this.userRoleCode = 0;
        }
      }
    }
  }
};
</script>

<style scoped>
.manage-sidebar {
  width: 240px;
  height: 100vh;
  background-color: #1f2937;
  color: white;
  transition: width 0.3s ease;
  overflow: hidden;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
}

.manage-sidebar.collapsed {
  width: 64px;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #374151;
}

.sidebar-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-placeholder {
  width: 0;
  overflow: hidden;
}

/* 淡入淡出过渡效果 */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  width: 0;
  overflow: hidden;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
  width: auto;
}

.collapse-btn {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.collapse-btn:hover {
  background-color: #374151;
}

.sidebar-menu {
  padding: 16px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: #9ca3af;
  text-decoration: none;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.menu-item:hover {
  background-color: #374151;
  color: white;
}

.menu-item.active {
  background-color: #3b82f6;
  color: white;
  border-left-color: #60a5fa;
}

.menu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 18px;
  flex-shrink: 0;
}

.manage-sidebar:not(.collapsed) .menu-icon {
  margin-right: 12px;
}

.menu-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
}

.menu-text-placeholder {
  width: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}
</style>
